var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSave = function SvgIconSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 16,
    height: 16,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.125 0H0v512h512V71.875zM281.6 31.347h31.347v94.041H281.6zm-145.241 0h113.894v125.388h94.041V31.347h32.392v156.735H136.359zm281.6 449.306H94.041V344.816h323.918zm0-167.184H94.041v-31.347h323.918zm62.694 167.184h-31.347V250.775H62.694v229.878H31.347V31.347h73.665v188.082h303.02V31.347h19.108l53.512 53.512v395.794z"
  })));
};
export default SvgIconSave;